//引入路由
import router from "./index";
import store from "@/store";
import { getSessionToken } from "@/utils/cache";
import { isSessionValid, logoutIfExpired } from "@/utils/auth";

/** 未登录可访问：登录页、移动端提示页、根路径（会重定向到登录） */
function isPublicAuthRoute(to) {
  if (to.meta?.public === true) return true;
  return (
    to.name === "Login" ||
    to.name === "Login2" ||
    to.name === "LoginMobileHint"
  );
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const token = getSessionToken();

  // 未登录且访问需登录页面 → 登录页
  if (!isPublicAuthRoute(to) && !token) {
    return next({ name: "Login" });
  }

  // 有 token 但 JWT 已过期（本地 exp 校验，无需请求后端）
  if (!isPublicAuthRoute(to) && token && !isSessionValid(token)) {
    logoutIfExpired();
    return next({ name: "Login" });
  }

  // 已登录仍访问登录相关入口 → 进后台
  if (isPublicAuthRoute(to) && isSessionValid(token)) {
    return next({ name: "Main" });
  }

  next();
});

// 同步当前路径，供侧栏等使用（与 el-menu 的 index 一致，使用 path 不含 hash）
router.afterEach((to) => {
  store.commit("app/SET_CURRENT_PATH", to.path);
});
